<mat-form-field 
appearance="fill" class="component-box" [formGroup]="group" [ngClass]="{'error-border':required}">
<mat-label>{{label}}{{required?" (Required)":""}}</mat-label>
    <input matInput [formControlName]="controlName" 
      [matAutocomplete]="auto" #inputClient    
      [appAutoFocus]="autofocus"  (blur)="this.onblur($event)"/>
    <mat-autocomplete   [disabled]='disable'  disableRipple  [appAutoFocus]="autofocus" 
    id="{{label}}" #auto="matAutocomplete" (optionSelected)="typeHeadChange($event)" >
        <mat-option  class="custom-option" *ngFor="let item of filteredList | sortBy:description" 
        [name]="item[description]" [title]="item[description]" [value]="item.clientName" >
            {{ item.clientName }}
        </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="required && group.controls[controlName].hasError('required')"> 
        <i class="fa-solid fa-circle-xmark"></i>
        You must first select a {{label}}. 
    </mat-error>
    <mat-error *ngIf="group.get(controlName)?.hasError('invalidClient')">
        <i class="fa-solid fa-circle-xmark"></i> Invalid Client
      </mat-error>   
      <mat-error *ngIf="group.get(controlName)?.hasError('invalidDashboardClient')">
        <i class="fa-solid fa-circle-xmark"></i> Invalid Client
      </mat-error>   
    
  

</mat-form-field>
